import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EmployeePlanAccountSchema = withDefaults({
  type: 'employee-plan-account',
  fields: [
    {
      kind: 'attribute',
      name: 'goodStanding',
    },
    {
      kind: 'attribute',
      name: 'goodStandingReason',
    },
    {
      kind: 'attribute',
      name: 'goodStandingDeterminedAt',
    },
    {
      kind: 'attribute',
      name: 'lockVersion',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'account',
      type: 'account',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default EmployeePlanAccountSchema;
